export enum Roles {
    Global = 101,
    GlobalDRMConfigurationRead = 401,
    GlobalDRMConfigurationWrite = 402,
    ChannelDRMConfigurationRead = 501,
    ChannelDRMConfigurationWrite = 502,
    EPGBlackoutRead = 601,
    EPGBlackoutWrite = 602
}
